import React, { useState } from "react";
import {
  FaStar,
  FaPhone,
  FaEnvelope,
  FaCalendarAlt,
  FaWallet,
  FaCheckCircle,
  FaTimesCircle,
  FaBan,
  FaStoreSlash,
  FaChevronDown,
} from "react-icons/fa";
import Phone from "../../Phone/Phone";

const statusConfig = {
  Approved: { color: "bg-green-100 text-green-800", icon: <FaCheckCircle /> },
  Rejected: { color: "bg-red-100 text-red-800", icon: <FaTimesCircle /> },
  "Business Off": { color: "bg-orange-100 text-orange-800", icon: <FaStoreSlash /> },
  Blocked: { color: "bg-gray-800 text-white", icon: <FaBan /> },
};

const UserDetail = ({ itemData, onClose, onStatusChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const currentStatus = itemData?.status || "Approved";

  const options = [
    { name: "Approved", value: "Approved" },
    { name: "Rejected", value: "Rejected" },
    { name: "Business Off", value: "Business Off" },
    { name: "Blocked", value: "Blocked" },
  ];

  const handleStatusChange = (status) => {
    onStatusChange?.(status);
    setIsOpen(false);
  };

  const current = statusConfig[currentStatus] || statusConfig.Approved;

  const renderStars = (rating = 4.0) => {
    const fullStars = Math.floor(rating);
    return (
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <FaStar
            key={star}
            className={`${star <= fullStars ? "text-yellow-400" : "text-gray-300"} text-lg`}
          />
        ))}
      </div>
    );
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div className="w-full h-full bg-gray-50 flex flex-col">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
        <h2 className="text-xl font-bold text-gray-800">
          {itemData?.first_name} {itemData?.last_name}
        </h2>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">
          ×
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-6 space-y-8">
        {/* Profile Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center gap-5">
            <div className="relative">
              <img
                src={itemData?.profile_image || "https://via.placeholder.com/150/6366f1/ffffff?text=User"}
                alt="User"
                className="w-20 h-20 rounded-full object-cover ring-4 ring-gray-100 shadow-md"
                onError={(e) => {
                  if (!e.target.src.includes("placeholder.com")) {
                    e.target.src = "https://via.placeholder.com/150/6366f1/ffffff?text=User";
                  }
                }}
              />
            </div>

            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900">
                {itemData?.first_name} {itemData?.last_name}
              </h3>
              <div className="flex items-center gap-3 mt-2">
                {renderStars(itemData?.rating || 4)}
                <span className="text-sm text-gray-600">User Rating</span>
              </div>
            </div>

            {/* Status Dropdown */}
            {/* <div className="relative">
              <p className="text-sm text-gray-500 mb-1 text-right">Account Status</p>
              <div className="relative">
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  className={`flex items-center gap-2 px-4 py-2.5 rounded-lg font-medium text-sm transition-all shadow-sm hover:shadow-md ${current.color}`}
                >
                  {current.icon}
                  <span>{currentStatus}</span>
                  <FaChevronDown className={`ml-2 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                </button>

                {isOpen && (
                  <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-xl border border-gray-200 z-50 overflow-hidden">
                    {options.map((option) => {
                      const config = statusConfig[option.value];
                      return (
                        <button
                          key={option.value}
                          onClick={() => handleStatusChange(option.value)}
                          className={`w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-gray-50 transition-all ${
                            currentStatus === option.value ? "bg-gray-100 font-semibold" : ""
                          }`}
                        >
                          <span className={config.color}>{config.icon}</span>
                          <span className="text-gray-800">{option.name}</span>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            </div> */}
          </div>
        </div>

        {/* Details Form */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 space-y-5">
          <div>
            <label className="text-sm font-medium text-gray-700">First Name</label>
            <input
              type="text"
              value={itemData?.first_name || ""}
              disabled
              className="mt-1 block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-gray-700"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700">Last Name</label>
            <input
              type="text"
              value={itemData?.last_name || ""}
              disabled
              className="mt-1 block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-gray-700"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700">Phone</label>
            <div className="mt-1">
              <Phone value={itemData?.phone_number} disabled />
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700">Email</label>
            <input
              type="text"
              value={itemData?.email || ""}
              disabled
              className="mt-1 block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-gray-700"
            />
          </div>
        </div>

        {/* Other Details */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-5">Other Details</h3>
          <div className="space-y-5">
            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm text-gray-600">Registered Date</p>
                <p className="font-medium text-gray-900 flex items-center gap-2 mt-1">
                  <FaCalendarAlt className="text-purple-600" />
                  {formatDate(itemData?.createdAt)}
                </p>
              </div>
            </div>

            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm text-gray-600">Wallet Balance</p>
                <p className="font-bold text-green-600 text-lg mt-1 flex items-center gap-2">
                  <FaWallet /> ₹0.00
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetail;